"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.PriceFlexContainer=exports.OrderItemWrapper=exports.ItemNameWrapper=void 0;const OrderItemWrapper=exports.OrderItemWrapper=_styledComponents.default.div`
    padding: 1rem 1rem 1rem 0;
    display: flex;
    column-gap: 8px;

    
  .qty {
    width: 58px;
    padding-top: 2px;
    font-weight: bold;
  }
`,ItemNameWrapper=exports.ItemNameWrapper=_styledComponents.default.div`
    min-width: 240px;
    max-width: 240px;
    /* height: 40px; */
   .itemName {
     display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
   }
 
`,PriceFlexContainer=exports.PriceFlexContainer=_styledComponents.default.div`
  display: flex;
  justify-content: space-between;

  .danger {
    color: red;
  }

  .strike {
    text-decoration: line-through;
  }
`;